import { HttpEvent, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, switchMap, throwError } from 'rxjs';
import { JRPCDto } from '@lentau/api/shared/jrpc/types';

export function jrpcErrorInterceptor(
  req: HttpRequest<unknown>,
  next: (req: HttpRequest<unknown>) => Observable<HttpEvent<unknown>>
): Observable<HttpEvent<unknown>> {
  return next(req).pipe(
    switchMap((res: HttpEvent<JRPCDto<unknown>>): Observable<HttpEvent<JRPCDto<unknown>>> => {
      if (res instanceof HttpResponse) {
        if (res?.body?.error) {
          return throwError(res.body.error);
        }
      }
      return of(res);
    })
  );
}
